/* ============================================================================
   WORKFLOW — Control Panel tab Flow (v3.9) · ADMIN SAHAJA sehingga disahkan hidup
   ============================================================================
   Reka bentuk dipersetujui user 2026-09-15; logik dibina hari sama.
   Workflow = resipi gambar untuk video, dipilih setiap kali run.
     Soalan 1 — Gambar dari mana?
                'generate' = Flow jana gambar dahulu, kemudian Animate (kelakuan lama)
                'kad'      = guna gambar pada card, tiada generate gambar
                             (contoh: storyboard daripada Agent Saya)
     ⛔ Baris berkunci "Setiap scene guna gambar mana?" DIBUANG 2026-09-16 (arahan user) —
        ia kawalan yang tidak boleh buat apa-apa. Jangan pasang semula sebagai paparan;
        bina fungsinya dahulu.

   Laluan nilai (dijejak hujung-ke-hujung):
     App.jsx `flowWorkflow` (useState) → prop WorkspaceView → simpan per-browser
     (sesaat_run_config_v1) + extensionSettings → payload Run Flow `settings.flowWorkflow`
     → jambatan extension menyalin `settings` bulat-bulat → skrip remote
     flow-automation-v3.js `_jalankanWorkflowKad` (AI8SAAT + SMART 1 babak sahaja).
   ⛔ Komponen ini RUPA SAHAJA — tiada simpanan, tiada semakan. Semakan sebelum Run
      (module disokong, had 3 gambar Veo) hidup dalam WorkspaceView.handleRunFlow.

   ⭐ `halangKad` (2026-09-16) = nama module kad yang DITANDA bila ia tidak menyokong
      mod card; null = menyokong / tiada kad ditanda. Ia hanya MELUMPUHKAN pilihan itu
      supaya pelanggan tidak sampai ke popup masa Run.
      ⛔ Ia TIDAK menukar `nilai` dan TIDAK menukar larian. Pilihan tersimpan pelanggan
         kekal, jadi menanda kad AI8SAAT semula memulangkan mod card seperti sedia kala;
         dan kalau kiraan module ini tersilap, pagar dalam handleRunFlow tetap menahan
         larian dengan BISING — bukan senyap-senyap bertukar ke mod generate.
   ========================================================================== */
import { useT } from '../i18n';

export default function WorkflowV39({ nilai = 'generate', onPilih, halangKad = null, cubaKad = false }) {
    const t = useT();
    const pilihan = [
        { id: 'generate', tajuk: t('workspace.workflow.optGenerate'), nota: t('workspace.workflow.optGenerateDesc') },
        { id: 'kad', tajuk: t('workspace.workflow.optCard'), nota: t('workspace.workflow.optCardDesc') },
    ];

    return (
        <div className="s-sect" style={{ padding: '0 0 16px', borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
            <p className="s-sect__title">{t('workspace.workflow.title')}</p>

            <div>
                <span className="s-lbl">{t('workspace.workflow.q1')}</span>
                <div role="radiogroup" aria-label={t('workspace.workflow.q1')} style={{ display: 'grid', gap: 6 }}>
                    {pilihan.map((p) => {
                        const on = nilai === p.id;
                        const mati = p.id === 'kad' && !!halangKad;
                        return (
                            <button
                                key={p.id}
                                type="button"
                                role="radio"
                                aria-checked={on}
                                disabled={mati}
                                onClick={() => { if (!mati) onPilih?.(p.id); }}
                                style={{
                                    display: 'flex', alignItems: 'flex-start', gap: 10,
                                    width: '100%', textAlign: 'left', font: 'inherit',
                                    padding: '10px 12px', borderRadius: 10,
                                    cursor: mati ? 'not-allowed' : 'pointer',
                                    opacity: mati ? 0.5 : 1,
                                    background: on ? 'var(--s-fill)' : 'transparent',
                                    border: `1px solid ${on ? 'var(--s-select)' : 'var(--s-line-strong)'}`,
                                    color: 'var(--s-ink)',
                                }}
                            >
                                <span
                                    aria-hidden="true"
                                    style={{
                                        width: 16, height: 16, borderRadius: '50%', flex: 'none', marginTop: 2,
                                        border: `1.5px solid ${on ? 'var(--s-select)' : 'var(--s-ink-3)'}`,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}
                                >
                                    {on && <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--s-select)' }} />}
                                </span>
                                <span style={{ minWidth: 0 }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 500, lineHeight: 1.4 }}>
                                        {p.tajuk}
                                        {mati && <span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: 14, color: 'var(--s-ink-3)' }}>lock</span>}
                                    </span>
                                    <span className="s-hint" style={{ display: 'block', margin: '2px 0 0' }}>{p.nota}</span>
                                </span>
                            </button>
                        );
                    })}
                </div>
                {/* ⭐ 2026-09-30 — Amaran ini keluar HANYA bila pelanggan betul-betul cuba guna
                    "Guna gambar pada card" (pilihan tersimpan = 'kad') tetapi kad yang ditanda
                    tidak menyokongnya. Dahulu ia terikat pada `halangKad` sahaja, jadi ia menegur
                    walaupun pelanggan sedang di "Generate di Flow" (default) — mengelirukan, macam
                    ada masalah sedangkan tiada. Gembok pada pilihan card (di atas) kekal supaya
                    pelanggan tahu ia wujud tetapi terkunci untuk module ini. */}
                {halangKad && cubaKad && (
                    <p className="s-hint" style={{ margin: '6px 0 0', color: 'var(--s-warn)' }}>
                        {t('workspace.workflow.kadTakSokong', { module: halangKad })}
                    </p>
                )}
            </div>

        </div>
    );
}
